export interface BrowserAgentInfo {
	browserName: string;
	os: string;
	deviceType: string;
	userAgent: string;
	platform: string;
	vendor: string;
}

const enum BrowserName {
	Firefox = 'Firefox',
	SamsungInternet = 'Samsung Internet',
	Opera = 'Opera',
	InternetExplorer = 'Internet Explorer',
	MicrosoftEdge = 'Microsoft Edge',
	Chrome = 'Chrome',
	Safari = 'Safari',
	Unknown = 'Unknown',
}

const enum DeviceType {
	Desktop = 'Desktop',
	Mobile = 'Mobile',
	Tablet = 'Tablet',
}

const enum OperatingSystem {
	Windows = 'Windows',
	MacOS = 'MacOS',
	Linux = 'Linux',
	Android = 'Android',
	iOS = 'iOS',
	Unknown = 'Unknown',
}

export const getBrowserAgent = (): BrowserAgentInfo => {
	const userAgent = navigator.userAgent;
	const platform = navigator.platform;
	const vendor = navigator.vendor;

	// Detect Browser
	let browserName: BrowserName = BrowserName.Unknown;
	if (userAgent.indexOf('Firefox') > -1) {
		browserName = BrowserName.Firefox;
	} else if (userAgent.indexOf('SamsungBrowser') > -1) {
		browserName = BrowserName.SamsungInternet;
	} else if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
		browserName = BrowserName.Opera;
	} else if (userAgent.indexOf('Trident') > -1) {
		browserName = BrowserName.InternetExplorer;
	} else if (userAgent.indexOf('Edge') > -1) {
		browserName = BrowserName.MicrosoftEdge;
	} else if (userAgent.indexOf('Chrome') > -1) {
		browserName = BrowserName.Chrome;
	} else if (userAgent.indexOf('Safari') > -1) {
		browserName = BrowserName.Safari;
	}

	// Detect Operating System
	let os: OperatingSystem = OperatingSystem.Unknown;
	if (platform.indexOf('Win') > -1) {
		os = OperatingSystem.Windows;
	} else if (platform.indexOf('Mac') > -1) {
		os = OperatingSystem.MacOS;
	} else if (platform.indexOf('Linux') > -1) {
		os = OperatingSystem.Linux;
	} else if (/Android/.test(userAgent)) {
		os = OperatingSystem.Android;
	} else if (/iOS|iPhone|iPad|iPod/.test(userAgent)) {
		os = OperatingSystem.iOS;
	}

	// Detect Device Type
	let deviceType = DeviceType.Desktop;
	if (/Mobi|Android/i.test(userAgent)) {
		deviceType = DeviceType.Mobile;
	} else if (/Tablet|iPad/i.test(userAgent)) {
		deviceType = DeviceType.Tablet;
	}

	return {
		browserName,
		os,
		deviceType,
		userAgent,
		platform,
		vendor,
	};
};

export default getBrowserAgent;
